<template>
<div class="card-item"
  :id="item.itemId">
  <div class="card-item-content">
    <div class="input-item">
      <label for="">会社名</label>
      <Input placeholder="株式会社○○"
        v-model="item.data.companyName" />
    </div>
    <div class="input-item">
      <label for="">設立年</label>
      <my-date v-bind:date="item.data.establishedDate" />
    </div>
    <div class="input-item">
      <label for="">代表取締役</label>
      <Input placeholder=""
        v-model="item.data.ceo" />
    </div>
    <div class="input-item">
      <label for="">資本金</label>
      <Input placeholder="○○○万円"
        v-model="item.data.capital" />
    </div>
    <div class="input-item">
      <label for="">郵便番号</label>
      <Input placeholder="000-0000"
        v-model="item.data.address.postalCode" />
      <label for="">住所</label>
      <Input placeholder="○○都○○区○○町○○"
        v-model="item.data.address.postalDetail" />
    </div>
    <div class="input-item">
      <label for="">電話番号</label>
      <Input placeholder="00-0000-0000"
        v-model="item.data.tel" />
    </div>
    <div class="input-item">
      <label for="">WEBサイトURL</label>
      <Input type="url"
        placeholder="https://abc.com"
        v-model="item.data.url" />
    </div>
    <div class="input-item">
      <label for="">事業内容</label>
      <Input type="textarea"
        :autosize="{minRows: 1,maxRows: 10}"
        placeholder="事業の内容を具体的に説明しましょう"
        v-model="item.data.businessContentsSimple" />
    </div>
  </div>
</div>
</template>

<script>
export default {
  data() {
    return {}
  },
  props: ['item'],
  computed: {},
  mounted: function () {},
  methods: {},
  watch: {}
}
</script>
